import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { delay, put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { GetThirdPartyUserSubServicesHistoryDataTypes } from "../../../../Schema/getThirdPartyUserSubServicesHistory.types";
import { call } from "@redux-saga/core/effects";
import { queryClient } from "../../../store";

export type GetThirdPartyUserSubServicesHistoryLoadAction = {
  type: string;
};

export type GetThirdPartyUserSubServicesHistoryData = {
  data: {
    sub_services: GetThirdPartyUserSubServicesHistoryDataTypes[];
  };
};

const GetThirdPartyUserSubServicesHistory = new ReduxFetchState<
  GetThirdPartyUserSubServicesHistoryData | null,
  any
>("getThirdPartyUserSubServicesHistory");

export function* watchGetThirdPartyUserSubServicesHistory(
  action: GetThirdPartyUserSubServicesHistoryLoadAction,
) {
  try {
    const lang: "fa" | "en" = yield getCurrentLanguage();

    // To avoid calling the api before creation
    // yield delay(800);
    const data: GetThirdPartyUserSubServicesHistoryData = yield call(
      [queryClient, queryClient.fetchQuery],
      {
        queryKey: ["getThirdPartyUserSubServicesHistory", lang],
        queryFn: async () => {
          const res = await axios({
            url: "/api/v1/ai/third-party/user-sub-services/history",
            method: "GET",
            headers: { lang },
          });

          return { data: res.data };
        },
        staleTime: 5 * 60 * 1000,
      },
    );

    yield put(
      GetThirdPartyUserSubServicesHistory.actions.loadSuccess({
        data: data.data,
      }),
    );
  } catch (e: any) {
    setTimeout(function* () {
      yield put(GetThirdPartyUserSubServicesHistory.actions.load());
    }, 5000);
    yield put(GetThirdPartyUserSubServicesHistory.actions.loadFailure(e?.response?.data));
  }
}

export function* getThirdPartyUserSubServicesHistorySagas() {
  yield takeEvery(
    GetThirdPartyUserSubServicesHistory.actionTypes.load,
    watchGetThirdPartyUserSubServicesHistory,
  );
}

export function useGetThirdPartyUserSubServicesHistory() {
  const { loading, data, ...getThirdPartyUserSubServicesHistoryState } = useAppSelector(
    (state) => state.getThirdPartyUserSubServicesHistory,
  );
  const dispatch = useAppDispatch();

  const dispatchGetThirdPartyUserSubServicesHistory = useCallback(() => {
    dispatch(GetThirdPartyUserSubServicesHistory.actions.load());
  }, [dispatch]);

  return {
    ...getThirdPartyUserSubServicesHistoryState,
    dispatchGetThirdPartyUserSubServicesHistory,
    getThirdPartyUserSubServicesHistoryLoading: loading,
    getThirdPartyUserSubServicesHistoryData: data,
  };
}

export const {
  actionTypes: getThirdPartyUserSubServicesHistoryActionsTypes,
  actions: getThirdPartyUserSubServicesHistoryActions,
  reducer: getThirdPartyUserSubServicesHistoryReducer,
} = GetThirdPartyUserSubServicesHistory;
